<script setup lang="ts">
import { cn } from '@/lib/utils'
import { ChevronDown } from 'lucide-vue-next'
import { SelectIcon, SelectTrigger, type SelectTriggerProps, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<
  SelectTriggerProps & {
    class?: HTMLAttributes['class']
    variant?: 'searchForm' | string
    ariaLabel?: string
  }
>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <SelectTrigger
    v-bind="forwardedProps"
    :class="
      cn(
        'flex w-full items-center justify-between rounded-md border bg-white py-2 text-start text-sm ring-offset-white focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-red-200 aria-[invalid=true]:bg-red-50 aria-[invalid=true]:focus-visible:ring-red-500 data-[placeholder]:text-gray-500 [&>span]:truncate',
        props.variant === 'searchForm' ? 'h-[52px] px-4' : 'h-9 px-3',
        props.class
      )
    "
    :aria-label="props.ariaLabel"
  >
    <slot />
    <SelectIcon as-child>
      <ChevronDown class="h-4 w-4 shrink-0 opacity-50" />
    </SelectIcon>
  </SelectTrigger>
</template>
